// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/fond_hadron_2.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/fond_estrive_2.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.espaceHautAccueil {
    height:15vh;
}

/* Section présentation */
.imgLivres {
    margin-bottom: -80px;
    position: relative;
    z-index: 1; /* les livres débordent sur le parchemin (positionné) qui suit */
}

.imgLivres .livre1 {
    width:300px;
}
.imgLivres .livre2 {
    width:250px;
}

.fondParchemin.fondImagesAccueil {
    padding: 20px 25px 10px; /* le cadre parchemin ajoute déjà ~70px */
}

.iconesPresentation {
    width: auto;
    height: 150px;
    margin: auto;
    align-items: center;
    display: flex;
}

/* Section Avez-vous trouvé la Clef ? */ 
.background-fin-key {
    width: 100%;
    /*height: 330px;*/
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% auto;
    /* Largeur 100%, hauteur ajustée */
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-left:0;
    margin:50px auto;
}

.clefAstolie {
    padding-left:0;
}
.clefAstolie img, .clefEstRive img {
    width:250px;
}
.clefAstolie .btn, .clefEstRive .btn {
    margin-top: -30px;
    position: relative;
}

.vertical-align {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

/* Section actualités */
.sectionActus {
    padding: 0 20px;
    color:#030303;
    margin-top: 50px;
}

.sectionActus h2 {
    color:#F3ECD2;
}

.apercuActus {
    padding-right:20px;
    padding-left:20px;
    margin-top: -160px;
}

.apercuActus h3 {
    margin-top: 10px;
    color: #030303;
}

.backgroundActus {
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% auto;
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-right:50px;
    margin:-30px auto 0;
    height:350px;
}

/* ---------- */
/* Responsive */
/* ---------- */
@media (max-width:992px) {
    .espaceHautAccueil {
        height: 5vh;
    }
    .infos {
        text-align:center;
    }

    .background-fin-key {
        background-image: none !important;
        flex-direction: column-reverse;
        text-align: center; 
    }
    .clefAstolie img, .clefEstRive img {
        display: block;
        margin:auto;
    }
    .clefAstolie .btn, .clefEstRive .btn {
        margin: -30px auto 30px;
    }
    .background-fin-key .subtitle {
        color: #F3ECD2;
    }

    .sectionActus {
        text-align:center;
        color: #F3ECD2;
        margin-top: 0px;
    }
    .backgroundActus {
        background-image: none !important;
        text-align: center; 
        margin-top:0;
        padding-right: 0;
        height:auto;
    }
    .apercuActus {
        margin-top:0;
    }
    .apercuActus h3 {
        color: #F3ECD2;
    }
}

@media (max-width: 670px) {
    .espaceHautAccueil {
        height:0;
    }

    .imgLivres {
        margin-bottom: -90px;
    }
    .imgLivres .livre1 {
        width:180px;
    }
    .imgLivres .livre2 {
        width:160px;
    }
    .fondParchemin.fondImagesAccueil {
        padding: 20px 5px 5px;
    }
    .iconesPresentation {
        height: 120px;
        margin: 20px auto 0;
    }
    .apercuActus .row {
        gap:35px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,kBAAkB;IAClB,UAAU,EAAE,gEAAgE;AAChF;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB,EAAE,yCAAyC;AACtE;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,iBAAiB;IACjB,yDAAuD;IACvD,0BAA0B;IAC1B,kCAAkC;IAClC,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yDAAwD;IACxD,0BAA0B;IAC1B,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,eAAe;AACf,eAAe;AACf,eAAe;AACf;IACI;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,eAAe;IACnB;IACA;QACI,iCAAiC;QACjC,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,oBAAoB;IACxB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,QAAQ;IACZ;AACJ","sourcesContent":[".espaceHautAccueil {\n    height:15vh;\n}\n\n/* Section présentation */\n.imgLivres {\n    margin-bottom: -80px;\n    position: relative;\n    z-index: 1; /* les livres débordent sur le parchemin (positionné) qui suit */\n}\n\n.imgLivres .livre1 {\n    width:300px;\n}\n.imgLivres .livre2 {\n    width:250px;\n}\n\n.fondParchemin.fondImagesAccueil {\n    padding: 20px 25px 10px; /* le cadre parchemin ajoute déjà ~70px */\n}\n\n.iconesPresentation {\n    width: auto;\n    height: 150px;\n    margin: auto;\n    align-items: center;\n    display: flex;\n}\n\n/* Section Avez-vous trouvé la Clef ? */ \n.background-fin-key {\n    width: 100%;\n    /*height: 330px;*/\n    background-image: url('/public/img/fond_hadron_2.webp');\n    background-size: 100% auto;\n    /* Largeur 100%, hauteur ajustée */\n    background-position: right;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    padding-left:0;\n    margin:50px auto;\n}\n\n.clefAstolie {\n    padding-left:0;\n}\n.clefAstolie img, .clefEstRive img {\n    width:250px;\n}\n.clefAstolie .btn, .clefEstRive .btn {\n    margin-top: -30px;\n    position: relative;\n}\n\n.vertical-align {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n/* Section actualités */\n.sectionActus {\n    padding: 0 20px;\n    color:#030303;\n    margin-top: 50px;\n}\n\n.sectionActus h2 {\n    color:#F3ECD2;\n}\n\n.apercuActus {\n    padding-right:20px;\n    padding-left:20px;\n    margin-top: -160px;\n}\n\n.apercuActus h3 {\n    margin-top: 10px;\n    color: #030303;\n}\n\n.backgroundActus {\n    width: 100%;\n    background-image: url('/public/img/fond_estrive_2.webp');\n    background-size: 100% auto;\n    background-position: right;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    padding-right:50px;\n    margin:-30px auto 0;\n    height:350px;\n}\n\n/* ---------- */\n/* Responsive */\n/* ---------- */\n@media (max-width:992px) {\n    .espaceHautAccueil {\n        height: 5vh;\n    }\n    .infos {\n        text-align:center;\n    }\n\n    .background-fin-key {\n        background-image: none !important;\n        flex-direction: column-reverse;\n        text-align: center; \n    }\n    .clefAstolie img, .clefEstRive img {\n        display: block;\n        margin:auto;\n    }\n    .clefAstolie .btn, .clefEstRive .btn {\n        margin: -30px auto 30px;\n    }\n    .background-fin-key .subtitle {\n        color: #F3ECD2;\n    }\n\n    .sectionActus {\n        text-align:center;\n        color: #F3ECD2;\n        margin-top: 0px;\n    }\n    .backgroundActus {\n        background-image: none !important;\n        text-align: center; \n        margin-top:0;\n        padding-right: 0;\n        height:auto;\n    }\n    .apercuActus {\n        margin-top:0;\n    }\n    .apercuActus h3 {\n        color: #F3ECD2;\n    }\n}\n\n@media (max-width: 670px) {\n    .espaceHautAccueil {\n        height:0;\n    }\n\n    .imgLivres {\n        margin-bottom: -90px;\n    }\n    .imgLivres .livre1 {\n        width:180px;\n    }\n    .imgLivres .livre2 {\n        width:160px;\n    }\n    .fondParchemin.fondImagesAccueil {\n        padding: 20px 5px 5px;\n    }\n    .iconesPresentation {\n        height: 120px;\n        margin: 20px auto 0;\n    }\n    .apercuActus .row {\n        gap:35px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
